import { ref, useContext } from "@nuxtjs/composition-api";
const ENDPOINT = "/api/aggregated/shops";
function useShops(initialParams) {
  const { $axios } = useContext();
  const shops = ref([]);
  const meta = ref({});
  const isLoading = ref(false);
  const fetchShops = async () => {
    try {
      isLoading.value = true;
      const { data } = await $axios.get(ENDPOINT, { params: initialParams });
      shops.value = data.data;
      meta.value = data.meta;
    } catch (error) {
      console.error("Failed to fetch shops:", error);
    } finally {
      isLoading.value = false;
    }
  };
  return { shops, meta, fetchShops, isLoading };
}
export {
  useShops as default
};
